export default __webpack_public_path__ + "static/media/hht2_home_img_EP16.57b5e4c1.png";